<template>
  <section>
    <wx-open-launch-app
      v-if="useWxOpenLaunchAppTag"
      ref="wxOpenLaunchAppRef"
      :appid="VITE_OPEN_APP_APPID"
      :extinfo="extinfo"
    >
      <component :is="'script'" type="text/wxtag-template">
        <slot name="default" />
      </component>
    </wx-open-launch-app>
    <a v-else :data-href="openAppLink" @click.capture="onOpenAppLinkClick">
      <slot name="default" />
    </a>
  </section>
</template>

<script setup lang="ts">
import { browerVersion } from '@/utils';
import { toFunDetail } from '@/utils/appSdk';

const {
  VITE_OPEN_APP_APPID,
  VITE_OPEN_APP_DOMAIN,
  VITE_ANDROID_OPEN_APP_LINK,
  VITE_IOS_OPEN_APP_LINK,
  VITE_PROJECT_APP_DOWNLOAD_URL,
} = import.meta.env;
defineOptions({ name: 'OpenAppBtn' });

const props = defineProps<{
  extinfo: string;
}>();

const version = browerVersion();
const currentHost = window.location.host;
const useWxOpenLaunchAppTag = computed(
  () => version.weixin && version.android && currentHost === VITE_OPEN_APP_DOMAIN,
);

const wxOpenLaunchAppRef = ref();
if (useWxOpenLaunchAppTag.value) {
  useEventListener(wxOpenLaunchAppRef, 'error', (e: any) => {
    console.error(new Error(e.detail));
  });
}

const siteInfo = inject<Site.SiteDownloadInfo>('siteInfo', {
  guidePic: '',
  downloadUrl: VITE_PROJECT_APP_DOWNLOAD_URL,
});
const openAppLink = computed(() => {
  const data = props.extinfo;
  if (version.android) {
    return `${VITE_ANDROID_OPEN_APP_LINK}?data=${data}`;
  }
  if (version.ios) {
    return `${VITE_IOS_OPEN_APP_LINK}?data=${data}`;
  }
  return siteInfo.downloadUrl || VITE_PROJECT_APP_DOWNLOAD_URL;
});

const visibility = useDocumentVisibility();
let timeoutStop: () => void;
const onOpenAppLinkClick = () => {
  if (version.myApp) {
    toFunDetail(props.extinfo);
    return;
  }
  window.location.href = openAppLink.value;
  const { stop } = useTimeoutFn(() => {
    window.open(siteInfo.downloadUrl || VITE_PROJECT_APP_DOWNLOAD_URL);
  }, 5000);
  timeoutStop = stop;
};

watch(visibility, (val) => {
  if (val === 'hidden' && timeoutStop) {
    timeoutStop();
  }
});
</script>
